import * as bitcoinPlugin from '@exodus/bitcoin-plugin';
import * as bitcoinRegtestPlugin from '@exodus/bitcoinregtest-plugin';
import * as bitcoinTestnetPlugin from '@exodus/bitcointestnet-plugin';
import { customizePlugin } from '../utils/customize-plugin.js';
const sharedConfig = {
    omitSupportedPurposes: [86],
};
export const bitcoin = customizePlugin({
    assetPlugin: bitcoinPlugin,
    config: sharedConfig,
});
export const bitcoinregtest = customizePlugin({
    assetPlugin: bitcoinRegtestPlugin,
    config: sharedConfig,
});
export const bitcointestnet = customizePlugin({
    assetPlugin: bitcoinTestnetPlugin,
    config: sharedConfig,
});
